import apiClient from './_axios';

export interface SmsSettings {
   apiKey: string;
   senderName: string;
   enabled: boolean;
   message: string;
}

export const getSmsSettings = async (): Promise<SmsSettings> => {
   const response = await apiClient.get('/integration/sms');
   return response.data;
};

export const updateSmsSettings = async (data: SmsSettings) => {
   const response = await apiClient.put('/integration/sms', data);
   return response.data;
};

export const testSms = async (number: string) => {
   const response = await apiClient.post('/integration/sms/test', { number });
   return response.data;
};

export const getSmsBalance = async (): Promise<{ balance: number; status: string }> => {
   const response = await apiClient.get('/integration/sms/balance');
   return response.data;
};
